<template>
  <div>
    <v-toolbar color class="mb-1">
      <v-toolbar-title
        :style="{ color: getOutlineColor }"
        class="ml-1 mr-2"
        v-html="title"
      >
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="header"></slot>
    </v-toolbar>
    <v-virtual-scroll
      :items="items"
      :height="scrollHeigth"
      :item-height="itemHeigth"
    >
      <template v-slot:default="props">
        <v-list two-line>
          <v-list-item :key="props.index + Math.random()">
            <v-list-item-content>
              <slot name="content"></slot>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>
      </template>
    </v-virtual-scroll>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: null,
    },

    items: {
      type: Array,
      default(rawProps) {
        return [1];
      },
    },

    scrollHeigth: {
      default: 600,
    },

    itemHeigth: {
      default: 100,
    },
  },
  computed: {
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
  },
};
</script>

<style></style>
